import styled from 'styled-components';
import {NavLink} from 'react-router-dom';

export const DiscountsTabsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  border-bottom: 2px solid #d9d9d9;
  padding: 0;
  @media (max-width: 470px) {
    gap: 20px;
    justify-content: space-between;
  }
`;

export const DiscountsTab = styled(NavLink)`
  position: relative;
  padding: 14px 0;
  text-decoration: none;
  font-size: 16px;
  font-weight: 400;
  color: #2f3d48;
  transition: font-weight 0.2s;

  &.isActive {
    font-weight: 700;
  }

  &.isActive::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -2px;
    height: 2px;
    background-color: #2f3d48;
    border-radius: 2px;
  }
`;
